export default [
  {
    path: '/supplier-groups',
    name: 'supplier-groups',
    component: () =>
      import(
        /* webpackChunkName: "supplier-groups" */ '@/view/pages/supplier-group/SupplierGroup.vue'
      ),
    children: [
      {
        path: '/',
        name: 'list-supplier-group',
        component: () =>
          import(
            /* webpackChunkName: "supplier-groups-list" */ '@/view/pages/supplier-group/SupplierGroupList.vue'
          ),
        meta: {
          title: 'Danh sách nhóm nhà cung cấp - Clickbuy',
        },
      },
    ],
  },
];
